import { Formatter } from "./formatter";

declare const __brandColor: unique symbol


const toHex = (num: number) => {
    if (Number.isNaN(num) || num < 0 || num >= 256)
        throw new Error();
    return Math.floor(num).toString(16).padStart(2, '0');
}

export function RGB(red: number, green: number, blue: number): FormatRGB;
export function RGB(hex: string): FormatRGB;
export function RGB(): null;


export function RGB(red?: number | string, green?: number, blue?: number): FormatColor {
    if (typeof red == "number")
        return `#${toHex(red)}${toHex(green as number)}${toHex(blue as number)}`.toUpperCase() as FormatRGB
    else if (typeof red == "string")
        return `${red.startsWith('#') ? `` : `#`}${red}` as FormatRGB
    else
        return null
}


export type Format = {
    borders?: {
        top?: FormatBorder
        left?: FormatBorder
        right?: FormatBorder
        bottom?: FormatBorder
    }
    text?: {
        size?: number
        color?: FormatColor
        style?: string
        bold?: boolean
        underline?: boolean
        italic?: boolean
        align?: "center" | "left" | "right"
    }
    fill?: {
        color?: FormatColor
    }
}

type FormatRGB = string & { __brandColor: true }
export type FormatColor = FormatRGB | null
export type FormatBorderStyle = "single" | "double" | null
export type FormatBorder = { style?: FormatBorderStyle, color?: FormatColor } | null

function cI<T>(obj1: T | undefined, obj2: T | undefined, fn: (obj1: T, obj2: T) => T): T | undefined {
    return (obj1 !== undefined) ? (obj2 !== undefined) ? fn(obj1, obj2) : obj1 : obj2
}
function cV<T>(obj1: T | undefined, obj2: T | undefined): T | undefined {
    return (obj2 !== undefined) ? obj2 : obj1;
}
function combineBorder(border1: FormatBorder, border2: FormatBorder): FormatBorder {
    return (border2 && border1) ? { style: cV(border1.style, border2.style), color: cV(border1.color, border2.color) } : border2
}
export const formatter = () => Formatter((obj: Format) => JSON.stringify(obj), (obj1, obj2) => ({
    borders: cI(obj1.borders, obj2.borders, (borders1, borders2) => ({
        top: cI(borders1.top, borders2.top, combineBorder),
        left: cI(borders1.left, borders2.left, combineBorder),
        right: cI(borders1.right, borders2.right, combineBorder),
        bottom: cI(borders1.bottom, borders2.bottom, combineBorder),
    })),
    text: cI(obj1.text, obj2.text, (text1, text2) => ({
        size: cV(text1.size, text2.size),
        color: cV(text1.color, text2.color),
        style: cV(text1.style, text2.style),
        bold: cV(text1.bold, text2.bold),
        underline: cV(text1.underline, text2.underline),
        italic: cV(text1.italic, text2.italic),
        align: cV(text1.align, text2.align)
    })),
    fill: cV(obj1.fill, obj2.fill)
}))
